<template>
  <div>
    <Transition name="loader">
      <UiLoading
        v-if="magicToken || isLoggedIn"
        :label="$t('account.sign-in.in-progress')"
      ></UiLoading>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/Auth';
import { storeToRefs } from 'pinia';
import { extractStartEndDates } from '@/utils';

const store = useAuthStore();
const { login } = store;
const { query } = useRoute();
const router = useRouter();
const localePath = useLocalePath();
const { signInVisible } = useOverlay();

const { isLoggedIn } = storeToRefs(store);

const magicToken = computed(() => {
  if (!query.token) return null;
  return typeof query.token === 'string' ? query.token : query.token[0];
});

onBeforeMount(() => {
  if (magicToken.value) {
    login(magicToken.value);
    if (query.redirectPath && typeof query.redirectPath === 'string') {
      const { setSearchDate } = useSearch();
      const redirectUrl = decodeURIComponent(query.redirectPath);
      const { start, end } = extractStartEndDates(redirectUrl);
      setSearchDate(start, end);
      router.replace(redirectUrl);
    } else {
      router.push(localePath({ name: 'account' }));
    }
  } else if (isLoggedIn.value) {
    router.push(localePath({ name: 'account' }));
  } else {
    signInVisible.value = true;
    router.push(localePath('/'));
  }
});
</script>
